<template>
  <div class="slider-container">
    <!-- <input class="slider-input" type="range" value="1" min="1" max="125" step="1" list="my-detents" v-model="sliderValue" @input="updateSliderWidth"/> -->
    <!-- <input class="slider-input" type="range" value="1" :min="min" :max="max" step="1" list="my-detents"
      v-model="sliderValue"  /> -->
      <Slider
      v-model="sliderValue"
      :min="min"
      :max="max"
      :marks="marks"
      :show-tooltip="false"
      >
    </Slider>
    <div>
      <!-- <div class="slider-track-thumb" :style="{ width: thumbWidth }"></div> -->

      <!-- <div v-for="value in sliderValues" :key="value" class="slider-dot" :style="{
        left: value == max ? `${((value == max ? value : value - 1) / max) * 100}%` : `${((value == max ? value : value - 1) / max) * 101}%`
      }" :class="{ active: sliderValue >= value }">
        <div class="label" :style="{ left: `${value < 100 ? 1 : -5}px` }">{{ value }}x</div>
      </div> -->
      <!-- <div class="slider-track-thumb" :style="{ width: thumbWidth }"></div>
      <div class="slider-dot" :class="{ active: sliderValue >= 0}">
        <div class="label">1x</div>
      </div>
      <div class="slider-dot" style="left: 20%" :class="{ active: sliderValue >= 25 }">
        <div class="label" style="left: -1px">25x</div>
      </div>
      <div class="slider-dot" style="left: 39.5%" :class="{ active: sliderValue >= 50 }">
        <div class="label" style="left: -2px;">50x</div>
      </div>
      <div class="slider-dot" style="left: 60%" :class="{ active: sliderValue >= 75 }">
        <div class="label" style="left: -4px">75x</div>
      </div>
      <div class="slider-dot" style="left: 80%" :class="{ active: sliderValue >= 100 }">
        <div class="label" style="left: -5px;">100x</div>
      </div>
      <div class="slider-dot" style="left: 100%" :class="{ active: sliderValue >= 125 }">
        <div class="label" style="left: -13px;">125x</div>
      </div> -->
    </div>
    <!-- <datalist id="my-detents">
      <option value="25"></option>
      <option value="50"></option>
      <option value="75"></option>
      <option value="100"></option>
      <option value="125"></option>
    </datalist> -->
    <!-- <input type="hidden" v-model="textInput" /> -->
  </div>
</template>
<script>
import { Slider } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
export default {
  name: 'SliderLeverage',
  components:{
    Slider,
  },
  props: {
    value: {
      type: Number,
      default: 1,
    },
    leverageModeFlg: {
      type: Boolean,
      default: true,
    },
    min: {
      type: Number,
      default: 1,
    },
    max: [Number],
    divisor: [Number],
    mobileBefore:{
      type: Number,
      default: 1,
    },
    tierList:{
      type: Array,
    }
  },
  computed: {
    sliderValues() {
      let values1 = [1, 25, 50, 75, 100, 125];
      let values2 = [1, 15, 30, 45, 60, 75];
      // Generate slider values dynamically
      /* for (let i = this.min; i <= this.max; i += this.max / this.divisor) {
         console.log(i)
         if (i == this.min) {
           values.push(i);
         } else {
           values.push(i - 1);
         }
       } */
      if (this.max == 125) {
        return values1
      } else {
        return values2
      }
    },
  },
  watch: {
    sliderValue(newValue) {
      if (this.max < newValue){
        this.sliderValue = this.max;
      }
      this.updateSliderWidth(); // Update thumb width whenever sliderValue changes
    },  
    textInput(newValue) {
      // Update sliderValue based on textInput value
      if (newValue === '') {
        this.sliderValue = 0; // Set to 0 if the input is empty
      } else {
        const parsedValue = Number(newValue);
        if (!isNaN(parsedValue) && parsedValue >= this.min && parsedValue <= this.max) {
          this.sliderValue = parsedValue; // Update sliderValue if valid
        }
      }
    },
    value: {
      handler(newVal) {
        this.sliderValue = Number(newVal);
        this.thumbWidth = `${((newVal - 0) / (this.max - 0)) * 100}%`;
      }
    },
    mobileBefore: {
      handler(newVal){
        this.init();
      }
    }
  },
  data() {
    return {
      sliderValue: 0,
      thumbWidth: '0%',
      beforeValue: 0,
      textInput: '',
      marks: {
        1: '1',
        // 0: '0°C',
        // 8: '8°C',
        // 37: '37°C',
        // 50: {
        //   style: {
        //     color: '#3182f6'
        //   },
        //   label: this.$createElement('strong', '50%')
        // }
      },
    }
  },
  mounted() {
    // this.beforeValue = this.value;
    // if (this.value != undefined && this.value > 0) {
    //   this.sliderValue = this.value;
    //   this.thumbWidth = `${((this.value - 0) / (this.max - 0)) * 100}%`;
    // }
    this.init();
  },
  created() {
    // this.beforeValue = this.value;
    // if (this.value != undefined && this.value > 0) {
    //   this.sliderValue = this.value;
    //   this.thumbWidth = `${((this.value - 0) / (this.max - 0)) * 100}%`;
    // }
  },
  methods: {
    init(){
      this.beforeValue = this.value;
      if (this.value != undefined && this.value > 0) {
        this.sliderValue = this.value;
        this.thumbWidth = `${((this.value - 0) / (this.max - 0)) * 100}%`;
      }

      //슬라이더 마커 생성
      
      //this.marks = {1:'1', 25:'25', 50:'50', 75:'75', 100:'100', 125:'125'};
      let markList = {};
      if (this.tierList != null){
        for (let item of this.tierList){
          //화면표시여부가 Y이면
          if (item.viewFlg == "Y"){
            markList[item.maxLv] = String(item.maxLv) + 'x';
          }
        }
      }

      this.marks = markList;
      
    },
    updateSliderWidth() {
      // Calculates the width of the thumb based on the slider value
      //this.thumbWidth = `${(this.sliderValue / this.max) * 100}%`;
      // if (this.leverageModeFlg == false && this.sliderValue < this.beforeValue) {
      //   this.sliderValue = this.beforeValue;
      // }
      this.$emit("updateSliderLeverage", this.sliderValue);
    },
  },
};
</script>

<style lang="scss" scoped>

.slider-container {
  //width: 100%;
  position: relative;
  height: 25px;
  //margin: 10px 0 30px 0;
  margin: 2px 4px 30px 4px;

  /* border: 1px solid red; */
  .slider-input {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
    -webkit-appearance: none;
    width: 100%;
    height: 26px;
    border-radius: 5px;
    /* background: #d3d3d3; */
    outline: none;

    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      appearance: none;
      width: 11px;
      height: 11px;
      border-radius: 50%;
      background: white;
      border: 2px solid var(--btn-primary);
      cursor: pointer;

      /* margin-top: -17px; */
      @media (max-width: 800px) {
        width: 13px;
        height: 13px;
      }
    }

    /* &::-ms-thumb {
			margin-top: 0;
		} */
  }

  .slider-track {
    position: absolute;
    top: 11px;
    width: calc(100% - 9px);
    height: 2px;
    background-color: #dddddd;

    @media (max-width: 800px) {
      top: 12px;
      width: calc(100% - 9px);
    }

    .slider-track-thumb {
      width: 100%;
      height: 3px;
      background-color: var(--btn-primary);
    }

    .slider-dot {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 8px;
      height: 8px;
      border-radius: 50vh;
      background-color: #dddddd;

      @media (max-width: 800px) {
        /* top: 12px; */
        transform: translateY(-48%);
      }

      &.active {
        background-color: var(--btn-primary);
      }

      .label {
        position: absolute;
        top: 20px;
        /* left: 50%; */
        /* transform: translateX(-50%); */
        font-size: 10px;
      }
    }
  }
}

/* deep 선택자를 사용하여 스타일을 수정 */

//슬라이더 라벨
::v-deep .el-slider__marks-text {
  font-size: 12px;
}

//슬라이더 표시 지점
::v-deep .el-slider__marks-stop {
  background-color: #dedede;
  border-radius: 50vh;
  width: 10px;
  height: 10px;
  top: -3px;
}

//슬라이더 바색상
::v-deep .el-slider__bar {
  background-color: var(--btn-primary);
  height : 3px;
}

//슬라이더 백그라운드
::v-deep .el-slider__runway {
  height : 3px;
}

//슬라이더 현재버튼
::v-deep .el-slider__button {
  width: 12px;
  height: 12px;
}
</style>
